import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'
import { NavLink } from 'ui-components/NavLink'

export const List = styled.ul`
  list-style: none;
  margin: 0;

  ${mq({
    padding: ['30px 10px', '30px 10px', '0 40px'],
  })}
`

export const ListItem = styled.li`
  ${mq({
    display: ['block', 'block', 'inline-block'],
  })}
`

export const MenuLink = styled(NavLink)`
  align-items: left;
  display: flex;
  font-size: 14px;
  text-decoration: none;
  line-height: 24px;

  ${mq({
    padding: ['10px', '10px', '3px 20px 10px'],
  })}

  svg {
    display: block;
    height: 20px;
    width: 18px;
  }
`
